import React, { Fragment, useMemo } from 'react';
import cn from 'classnames';
import moment from 'moment';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Loader from '../../Loader';
import { useChartContext } from '../hooks';
import { mapHistoryList } from '../helpers';
import { HISTORY_DATE_FORMAT } from '../constants';

import styles from './styles.styl';

const HistoryWrapper = ({
  unit,
  onLoad,
  loading,
  onClick,
  isModal,
  data = [],
  intl: { formatMessage },
}) => {
  const {
    mark,
    formats,
    converter = noop,
    shouldConvertToFahrenheit,
  } = useChartContext();

  const list = useMemo(() => mapHistoryList(data, { unit }, isModal), [
    data,
    unit,
    isModal,
  ]);

  return (
    <Fragment>
      <ul className={cn(styles.history, { [styles.modal]: isModal })}>
        {list.map(({ date, source, values }) => {
          const handleClick = () => {
            if (onClick) onClick({ date });
          };

          const clickable = onClick && {
            onClick: handleClick,
            'aria-hidden': true,
          };

          return (
            <li
              {...clickable}
              key={source + date}
              className={cn(styles.item, { [styles.pure]: isModal })}
            >
              <div>
                <b>{converter.func(values, shouldConvertToFahrenheit)}</b>
                <span className={cn(styles.sub, styles.light)}>{mark}</span>
              </div>
              <div className={styles.info}>
                <div className={styles.sub}>
                  {['day'].includes(unit)
                    ? moment(date).calendar(null, HISTORY_DATE_FORMAT)
                    : moment(date).format('LT')}
                </div>
                <div className={cn(styles.sub, styles.light)}>
                  {formats[source]}
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      {onLoad && (
        <div className={styles.load}>
          {loading && <Loader className={styles.loader} />}
          {!loading && (
            <div aria-hidden onClick={onLoad}>
              {formatMessage({ id: 'patient.healthboard.list.loadMore' })}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

HistoryWrapper.propTypes = {
  data: PropTypes.array,
  unit: PropTypes.string,
  onLoad: PropTypes.func,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  isModal: PropTypes.bool,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(HistoryWrapper);



// WEBPACK FOOTER //
// ./src/components/common/Charts/HistoryWrapper/index.jsx